module.exports = __webpack_public_path__ + "static/media/nelipak.67f17fb1.png";